import { GET_MANY_REFERENCE, CREATE, UPDATE } from 'react-admin';
import { getAlternateStatus } from '../../helpers/invoiceHelpers';

const formatInvoiceItem = ({
  invoice: {
    id,
    billingDate,
    billingStatus,
    currency,
    isPaidExternally,
    pspName,
    pspReference,
    refundInProgress,
    paymentInProgress,
  },
  totalWithTax,
}) => ({
  id,
  invoiceDate: billingDate,
  invoiceYear: new Date(billingDate).getFullYear(),
  invoicesStatus: getAlternateStatus({
    mainStatus: billingStatus,
    refundInProgress,
    paymentInProgress,
    isPaidExternally,
  }),
  amount: `${totalWithTax} ${currency}`,
  isPaidExternally,
  currency,
  pspName,
  pspReference,
  type: 'SUBSCRIPTION', // is formatted (translated) by react-admin FunctionField
  paymentInProgress,
  refundInProgress,
});

const getSingleBusinessUnitInvoicesListPayload = (response, { pagination: { page, perPage } }) => {
  const formattedArray = response.Billing.map(formatInvoiceItem);

  const sliceStart = (page - 1) * perPage;
  const sliceEnd = page * perPage;

  return {
    data: formattedArray.slice(sliceStart, sliceEnd),
    total: response.Billing.length,
  };
};

const dataBusinessUnitInvoices = (res, params, type) => {
  switch (type) {
    case GET_MANY_REFERENCE:
      return {
        ...getSingleBusinessUnitInvoicesListPayload(res, params),
        id: res.id,
      };
    case CREATE:
      switch (params.field) {
        case 'refund':
          return {
            data: {
              ...params.data,
              invoicesStatus: 'REFUND_IN_PROGRESS',
              refundInProgress: true,
            },
          };

        case 'retryPayment':
          return {
            data: {
              ...params.data,
              invoicesStatus: res.data.billingStatus,
            },
          };

        default:
          break;
      }
      break;
    case UPDATE:
      return {
        data: {
          ...params.data,
          invoicesStatus: res.data.isPaidExternally ? 'PAID_EXTERNALLY' : res.data.invoicesStatus,
        },
      };
    default:
      break;
  }
  return res;
};

export default dataBusinessUnitInvoices;
